<template>
  <div>
    <div class="form" v-if="showForm">
      <div class="form-item">
        <div class="form-title">
          <div>异动基本信息</div>
          <el-button
            style="font-weight: bold; font-size: 16px; padding: 0;"
            type="text"
            icon="el-icon-back"
            @click="showForm = false"
          >
            返回列表
          </el-button>
        </div>
        <div class="form-content">
          <el-row class="form-row" :gutter="40">
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">企业名称：</div>
              <div class="form-content-value">{{ detailData.company_name }}</div>
            </el-col>
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">统一社会信用代码：</div>
              <div class="form-content-value">{{ detailData.company_credit_code }}</div>
            </el-col>
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">产品类型：</div>
              <div class="form-content-value">{{ detailData.product_name }}</div>
            </el-col>
          </el-row>
          <el-row class="form-row" :gutter="40">
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">最新申请日期：</div>
              <div class="form-content-value">{{ formatDateTime(detailData.apply_date) }}</div>
            </el-col>
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">最新预授信金额：</div>
              <div class="form-content-value">{{ detailData.credit_amt }}</div>
            </el-col>
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">预授信差额：</div>
              <div
                class="form-content-value"
                :style="{
                  color:
                    amt(detailData.credit_amt, detailData.last_credit_amt) > 0
                      ? 'red'
                      : amt(detailData.credit_amt, detailData.last_credit_amt) < 0
                      ? 'green'
                      : ''
                }"
              >
                {{ amt(detailData.credit_amt, detailData.last_credit_amt) > 0 ? '+' : ''
                }}{{ detailData.credit_amt - detailData.last_credit_amt }}
              </div>
            </el-col>
          </el-row>
          <el-row class="form-row" :gutter="40">
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">上次申请日期：</div>
              <div class="form-content-value">
                {{ detailData.last_apply_date ? formatDateTime(detailData.last_apply_date) : '无' }}
              </div>
            </el-col>
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">上次预授信金额：</div>
              <div class="form-content-value">{{ detailData.last_credit_amt }}</div>
            </el-col>
            <el-col :span="8" class="form-content-item">
              <div class="form-content-label">统计更新时间：</div>
              <div class="form-content-value">{{ formatDateTime(detailData.CreateTime, 'time') }}</div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="form-item">
        <div class="form-title">历史异动明细</div>
        <div class="form-content">
          <el-table border :data="detailData.detailList" style="width: 100%" max-height="400">
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column prop="apply_user_tel" label="申请人"></el-table-column>
            <el-table-column prop="company_name" width="300" label="企业名称"></el-table-column>
            <el-table-column prop="company_credit_code" label="统一社会信用代码"></el-table-column>
            <el-table-column prop="apply_date" label="申请日期">
              <template slot-scope="scope">
                <span>{{ formatDateTime(scope.row.apply_date) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="credit_amt" label="预授信金额"></el-table-column>
            <el-table-column prop="" label="状态">
              <template>
                <span>已统计</span>
              </template>
            </el-table-column>
            <el-table-column prop="CreateTime" label="入库时间">
              <template slot-scope="scope">
                <span>{{ formatDateTime(scope.row.CreateTime, 'time') }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <div v-else class="rpt-content">
      <div style="margin-bottom: 20px;">
        <div class="search-control-item">
          <el-input v-model="inputValue" placeholder="请输入内容" class="input-with-select" style="width: 500px;">
            <el-select style="width: 170px;" v-model="selectType" slot="prepend" placeholder="请选择">
              <el-option label="企业名称" value="company_name"></el-option>
              <el-option label="统一社会信用代码" value="credit_code"></el-option>
            </el-select>
          </el-input>
        </div>
        <el-button class="search-control-item" type="primary" icon="el-icon-search" @click="search('btn')">查询</el-button>
      </div>

      <el-table
        border
        v-loading="tableloading"
        :data="tableData"
        style="width: 100%"
        max-height="600"
        @row-dblclick="rowDblclick"
      >
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column prop="company_name" width="300" label="企业名称"></el-table-column>
        <el-table-column prop="credit_code" label="统一社会信用代码"></el-table-column>
        <el-table-column prop="product_name" label="产品类型"></el-table-column>
        <el-table-column prop="apply_user_tel" label="申请人"></el-table-column>
        <el-table-column prop="apply_date" label="最新申请日期">
          <template slot-scope="scope">
            <span>{{ formatDateTime(scope.row.apply_date) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="last_apply_date" label="上次申请日期">
          <template slot-scope="scope">
            <span>{{ scope.row.last_apply_date ? formatDateTime(scope.row.last_apply_date) : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="credit_amt" label="最新预授信金额"></el-table-column>
        <el-table-column prop="last_credit_amt" label="上次预授信金额"></el-table-column>
        <el-table-column prop="credit_code" label="预授信差额">
          <template slot-scope="scope">
            <span
              :style="{
                color:
                  amt(scope.row.credit_amt, scope.row.last_credit_amt) > 0
                    ? 'red'
                    : amt(scope.row.credit_amt, scope.row.last_credit_amt) < 0
                    ? 'green'
                    : ''
              }"
            >
              {{ amt(scope.row.credit_amt, scope.row.last_credit_amt) > 0 ? '+' : ''
              }}{{ scope.row.credit_amt - scope.row.last_credit_amt }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="CreateTime" label="统计更新时间">
          <template slot-scope="scope">
            <span>{{ formatDateTime(scope.row.CreateTime, 'time') }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="[50, 100, 200, 300]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/assets/js/request';
export default {
  name: 'anomaly',
  data() {
    return {
      showForm: false,
      detailData: {},
      detailList: [],
      selectType: 'company_name',
      inputValue: '',
      tableloading: false,
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      tableData: []
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    handleSizeChange(size) {
      this.pageSize = size;
      this.pageIndex = 1;
      this.search();
    },
    handleCurrentChange(index) {
      this.pageIndex = index;
      this.search();
    },
    search(type) {
      if (type == 'btn') this.pageIndex = 1;
      this.tableloading = true;
      request({
        url: `/api/rpt/ysx/change/log?${this.selectType}=${this.inputValue}&pageIndex=${this.pageIndex}&pageSize=${this.pageSize}`
      }).then(res => {
        this.tableloading = false;
        if (res.success) {
          this.tableData = res?.result?.YSXList;
          this.total = res?.result?.recordCount;
        }
      });
    },

    amt(start, end) {
      return start - end;
    },

    rowDblclick(row) {
      console.log(row);
      let { company_credit_code, credit_day_rpt_id } = row;
      request({
        url: '/api/rpt/ysx/change/log/info',
        data: {
          credit_day_rpt_id,
          credit_code: company_credit_code
        }
      }).then(res => {
        console.log(res);
        if (res.success) {
          this.detailData = res.result;
          this.showForm = true;
        }
      });
    }
  }
};
</script>

<style></style>
